import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt alle Trauerhallen zurück.
 */
export function getMourningHalls(): JQueryPromise<modelsGet.IMourningHall[]>
{
    var endpoint = new URI("api/mourning-halls");

    return api.get<modelsGet.IMourningHall[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Trauerhallen zurück.
 */
export function getMourningHall(id: number): JQueryPromise<modelsGet.IMourningHall>
{
    var endpoint = new URI("api/mourning-halls/" + id.toString());

    return api.get<modelsGet.IMourningHall>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(jsonData: modelsPost.IMourningHall): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/mourning-halls",
        data: JSON.stringify(jsonData)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, jsonData: modelsPost.IMourningHall): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/mourning-halls/${id}`,
        data: JSON.stringify(jsonData)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/mourning-halls/${id}`
    });
}